import { render } from "./EditInstitute.vue?vue&type=template&id=433f0a52&scoped=true"
import script from "./EditInstitute.vue?vue&type=script&lang=js"
export * from "./EditInstitute.vue?vue&type=script&lang=js"

import "./EditInstitute.vue?vue&type=style&index=0&id=433f0a52&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-433f0a52"

export default script